module.exports = __webpack_public_path__ + "static/media/linkedin.cb937d2b.png";